import meta          from './meta.json';
import parts         from './parts.json';
import chaptersIndex from './chapters-index.json';
import glossary      from './glossary.json';
import templates     from './templates.json';

import ch01 from './ch01.json';
import ch02 from './ch02.json';
import ch03 from './ch03.json';
import ch04 from './ch04.json';
import ch05 from './ch05.json';
import ch06 from './ch06.json';
import ch07 from './ch07.json';
import ch08 from './ch08.json';
import ch09 from './ch09.json';
import ch10 from './ch10.json';
import ch11 from './ch11.json';
import ch12 from './ch12.json';
import ch13 from './ch13.json';
import ch14 from './ch14.json';
import ch15 from './ch15.json';
import ch16 from './ch16.json';
import ch17 from './ch17.json';
import ch18 from './ch18.json';

export const chapters = {
  ch01, ch02, ch03, ch04, ch05, ch06,
  ch07, ch08, ch09, ch10, ch11, ch12,
  ch13, ch14, ch15, ch16, ch17, ch18,
};

// Total exercise items across all 18 chapters (counted from JSON)
export const TOTAL_EXERCISES = 49;

export { meta, parts, chaptersIndex, glossary, templates };
